import * as z from 'zod';

export const WidgetContactSchema = z.object({
  name: z.string().max(200).optional().default(''),
  email: z.string().email().optional().or(z.literal('')).default(''),
  message: z.string().min(1).max(5000),
});
